import { Dimensions } from 'react-native';
import { SIZES, PALETTE, MQ_TABLET } from '../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";

const WINDOW_WIDTH = Dimensions.get('window').width;
const WINDOW_HEIGHT = Dimensions.get('window').height;



export default MediaQueryStyleSheet.create({
  container: {
    flex: 1,
  },
  dateSelect: {
    flex: 1,
    flexDirection: "row",
    maxHeight: "73px",
    alignItems: 'center',
    marginTop: 16,
    height: 73,
    margin: 5,
    padding: 10,
    paddingLeft: 8

  },

  dateRangeSelector: {
    paddingHorizontal: 5,
    minHeight: 35,
    borderRadius: 5,
    borderWidth: 1,
    borderColor: '#a7a8aa',
    margin: 10,
  },
  date: {
    color: 'white'
  },
}, {
  [MQ_TABLET]: {
    mainWrapper: {
      width: WINDOW_WIDTH * 0.92,
      flexDirection: 'row',
      alignSelf: 'center',
      // marginTop:30,
      paddingBottom: 30,
      justifyContent: 'center',
    },
    leftWrapper: {
      width: WINDOW_WIDTH * 0.50,
      minHeight: WINDOW_HEIGHT * 0.7,
      alignSelf: 'flex-start',
      flexDirection: 'row',
      paddingRight: 20,
    },
    rightWrapper: {
      width: WINDOW_WIDTH * 0.42,
    },
    subItems: {
    },
    groupSelection: {
      borderTopWidth: 0,
    },
    tabletView: {
      flex: 1,
    },

  }
});
